import React, {useEffect, useState} from 'react'
import {connect} from "react-redux";
import Spinner from 'react-bootstrap/Spinner'
import './reset-code.scss';
import { Link } from 'react-router-dom'
import {http} from "~/services/http";
import classnames from 'classnames';
import logoImg from "~/assets/logo-text-vertical.svg";
import TextTranslate from '../../Components/TextTranslate/TextTranslate';
import LanguageSwitcher from '../../Components/LanguageSwitcher/LanguageSwitcher';
import { Form } from 'react-bootstrap';

const ResetCode = (props) => {

    const [email, setEmail] = useState('');
    const [event, setEvent] = useState(1);
    const [events, setEvents] = useState([]);
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleResetCode = () => {
        setLoading(true);

        const requestOptions = {
            headers: {
                "Content-Language": props.currentLanguage?.code
            }
        }

        const res = http.post('/auth/reset', {
            email: email,
            event_id: event
        }, requestOptions);

        res.then((response) => {
            setLoading(false);
            setMessage(response.data?.message);
            setStatus('success');
        }).catch((error) => {
            setLoading(false);
            setMessage(error.response.data?.message);
            setStatus('fail');
        });
    };

    const handleKeyPress = (e) => {
        if (e.keyCode === 13) {
            handleResetCode();
        }
    };

    useEffect(() => {
        async function fetchEvents() {
            await fetch('/api/events')
                .then(result => result.json())
                .then(data => setEvents(data));
        }
        fetchEvents();
    }, [])

    const getMessage = () => {

        if (!message) {
            return '';
        }

        let className = {
            'alert-error-text' : status === 'fail',
            'alert-success' : status === 'success',
        };

        return (
            <div className={classnames(className)} role="alert">
                {message}
            </div>
        );
    }

    return (
        <div className="container container-reset-code h-100 d-flex">
            <div className="row align-items-center">
                <div className="col-12">

                    <div className="card shadow p-sm-4 p-0 bg-white">
                        <div className="card-body text-center">
                            <div className="row">
                                <div className="col-12 mb-3">
                                    <img className="logo mb-3" src={logoImg}/>
                                    <h1 className="text-primary mb-0"><TextTranslate name="resetcode-title" fallback="Generate new code" textOnly/></h1>
                                </div>
                                <div className="col-12">
                                    <p>
                                        <TextTranslate name="resetcode-note" fallback="Enter your email address below and a new unique code will be sent to you." textOnly/>
                                    </p>
                                </div>
                                <div className="col-12 description">
                                    <form>
                                        <div className="form-group">
                                            <label className="form-label w-100 text-left">
                                                <TextTranslate name="resetcode-email" fallback="Email Address" textOnly/>
                                            </label>
                                            <input onChange={e => setEmail(e.target.value)}
                                                   onKeyDown={e => handleKeyPress(e)}
                                                   className="form-control"
                                                   type="text"/>
                                        </div>

                                        <div className="form-group mb-1">
                                            <label className="form-label w-100 text-left">Event</label>
                                            <Form.Control
                                                as="select"
                                                name="selectedEvent"
                                                onChange={(e) => setEvent(e.target.value)}
                                            >
                                                {
                                                    events.length ?
                                                    events.map(event => <option key={`event_option_${event.id}`} value={event.id}>{event.name}</option>)
                                                    :
                                                    <option>Loading events...</option>
                                                }
                                            </Form.Control>
                                        </div>

                                        <div className="form-group submit">
                                            {getMessage()}
                                            <button onClick={handleResetCode} type="button" disabled={loading || !events.length}
                                                    className="btn btn-primary w-100">
                                                {loading && <Spinner size="sm" animation="border"/>}
                                                <span>
                                                    <TextTranslate name="resetcode-button-title" fallback="Generate new code" textOnly/>
                                                </span>
                                            </button>
                                        </div>

                                    </form>

                                </div>
                                <div className="col-12">
                                    <Link className="link small" to="/">
                                        <TextTranslate name="resetcode-return-to-login" fallback="Go back to login" textOnly/>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <LanguageSwitcher className="no-header"/>
        </div>
    );
}

const mapStateToProps = (state) => ({
    currentLanguage: state.translations.currentLanguage,
    user: state.auth.user,
    isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(ResetCode);
